import { Directive, HostListener, OnInit, WritableSignal, signal } from "@angular/core";
import { OwlOptions } from 'ngx-owl-carousel-o';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
enum ItemWidth {
    Destop = 302,
    Tablet = 194,
    Mobile = 165,
}
@Directive()
export class PreviewItemBase implements OnInit {
    itemWidth: number;
    customOptions: WritableSignal<OwlOptions> = signal({
        margin: OwlCarouselSettings.Margin,
        autoWidth: true,
        loop: true,
        pullDrag: false,
        autoplay: OwlCarouselSettings.Autoplay,
        autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
        autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
        navSpeed: 700,
        navText: ['', ''],
        responsive: {
            0: { items: 2 },
            540: { items: 2 },
            740: { items: 3 },
        },
        dots: true
    });

    constructor() {
        this.setItemWidth(window.screen.width);
    }

    ngOnInit(): void { }

    @HostListener('window:resize', ['$event'])
    onWindowResize(event: any) {
        this.setItemWidth(event?.target.screen.width);
    }

    setItemWidth(screenSize: number) {
        if (screenSize >= 992) this.itemWidth = ItemWidth.Destop;
        if (screenSize < 992 && screenSize >= 425) this.itemWidth = ItemWidth.Tablet;
        if (screenSize < 425) this.itemWidth = ItemWidth.Mobile;
    }

    setLoop(value: boolean) {
        this.customOptions.update(state => ({ ...state, loop: value }));
    }
}